import { BudgetingIcon } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { useMemo } from 'react';
import bemFactory from 'react-bem-factory';
import { DomainIntegrationType } from 'shared/data/webApp/v2';
import { useIsBudgetingAvailable } from 'shared/hooks/useIsBudgetingAvailable';
import { getPath, Path } from 'urlBuilder';

import { useGetCompany } from '../../Drawer.hooks';
import { messages } from './BudgetingMenu.messages';

const qa = bemFactory.qa('drawerBudgeting');

export const useBudgetingLinkItems = (companyId: string) => {
    const { data: company } = useGetCompany(companyId);

    const isBudgetingAvailable = useIsBudgetingAvailable({
        integrationType: company?.integrationType,
        licenseFeatures: (company?.productPlanFeatures as domain.CompanyLicenseFeature[]) || [],
        betaFeatures: (company?.betaFeatures as domain.CompanyBetaFeature[]) || [],
    });
    const isQBooksIntegration = company?.integrationType === DomainIntegrationType.QBooks;

    return useMemo(() => {
        return [
            {
                id: Path.companyBudgetingV2,
                name: messages.budgetingName,
                available: isBudgetingAvailable,
                to: getPath(Path.companyBudgetingV2, company?.id),
                startIcon: BudgetingIcon,
                dataQa: qa(),
                isBeta: isQBooksIntegration,
            },
        ];
    }, [company?.id, isBudgetingAvailable, isQBooksIntegration]);
};
